<template>
  <div>

    <keep-alive>
      <router-view v-if="$route.meta.keepAlive" />
    </keep-alive>
      <router-view v-if="!$route.meta.keepAlive" />

    <van-tabbar route>
      <div class="tabBox">
        <div class="tabItem">
          <van-tabbar-item to="/order" icon="home-o">预约</van-tabbar-item>
        </div>
        <div class="tabItem">
          <van-badge :content="countMsgBadge" max="99">
            <van-tabbar-item to="/message" icon="chat-o">
              消息
            </van-tabbar-item>
          </van-badge>
        </div>
        <div class="tabItem">
          <van-tabbar-item to="/my" icon="friends-o">我的</van-tabbar-item>
        </div>
      </div>
    </van-tabbar>
  </div>
</template>
<script>
// import * as utils from '../api/utils'
import { mapState } from 'vuex'
export default {
  data () {
    return {
      active: 0,
      dotShow: null
    }
  },
  updated () {
    this.dispatchMsgBadge()
  },
  mounted () {
    this.dispatchMsgBadge()
  },
  computed: {
    ...mapState({
      countMsgBadge (state) {
        if (state.msgBadge) {
          return state.msgBadge.msgBadge
        } else {
          return 0
        }
      }
    })
  },
  methods: {
    dispatchMsgBadge () {
      if (!this.$store.state.msgBadge.msgBadge) {
        this.$store.dispatch('MSGBADGEACTION')
      }
    }
  }
}
</script>
<style scoped lang="scss">
.tabBox {
  width: 100%;
  display: flex;
  justify-content: space-around;
  align-items: center;
}
</style>
